import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Tab/sgds-tab-group";
import { register } from "../../utils/ce-registry";

register("sgds-tab-group", Component);

export default createComponent({
  react: React,
  tagName: "sgds-tab-group",
  elementClass: Component,
  events: {
    onSgdsTabShow: "sgds-tab-show",
    onSgdsTabHide: "sgds-tab-hide"
  }
});
